import React from "react";

import { Helmet } from "react-helmet-async";

import Hero from "@/sections/Hero";
import Pricing from "@/sections/Pricing";
import Services from "@/sections/Services";
import Text from "@/sections/Text";
import WorkMarguee from "@/sections/WorkMarguee";
import Features from "@/sections/Features";
import Faq from "@/sections/FAQ";
import About from "@/sections/About";
import Tech from "@/sections/Tech";
import Certificates from "@/sections/Certificates";

import WorkProcess from "@/sections/WorkProcess";
import BlogPreview from "@/sections/BlogPreview";
import Testimonials from "@/sections/Testimonials";
import Stats from "@/sections/Stats";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>
          webbyj.io - Jakub Wawrysiewicz | Frontend Developer & UX/UI Designer
        </title>
        <meta
          name="description"
          content="Crafting modern websites & apps with cutting-edge tech. Explore Jakub Wawrysiewicz's portfolio – frontend developer skilled in React, Next.js & UX/UI."
        />
        <meta
          name="keywords"
          content="frontend developer, Jakub Wawrysiewicz, Webbyj.io, React, Next.js, UX/UI, tworzenie stron internetowych, aplikacje webowe, programista frontend, web development, JavaScript, TypeScript, responsive design, web design, portfolio"
        />
        <link rel="canonical" href="https://webbyj.io" />
        <meta name="author" content="Jakub Wawrysiewicz" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Webbyj.io" />
        <meta
          property="og:title"
          content="webbyj.io - Jakub Wawrysiewicz | Frontend Developer & UX/UI Designer"
        />
        <meta
          property="og:description"
          content="Crafting modern websites & apps with cutting-edge tech. Explore Jakub Wawrysiewicz's portfolio – frontend developer skilled in React, Next.js & UX/UI."
        />
        <meta
          property="og:image"
          content="https://webbyj.io/images/twitterCard.png"
        />
        <meta property="og:url" content="https://webbyj.io" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="webbyj.io - Jakub Wawrysiewicz | Frontend Developer"
        />
        <meta
          name="twitter:description"
          content="Crafting modern websites & apps with cutting-edge tech. Frontend developer skilled in React, Next.js & UX/UI."
        />
        <meta
          name="twitter:image"
          content="https://webbyj.io/images/twitterCard.png"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            name: "webbyj.io - Jakub Wawrysiewicz",
            url: "https://webbyj.io",
            logo: "https://webbyj.io/favicon/favicon.svg",
            description:
              "Frontend developer skilled in React, Next.js & UX/UI design",
            address: {
              "@type": "PostalAddress",
              addressCountry: "Poland",
            },
            sameAs: [
              "https://github.com/yourusername",
              "https://linkedin.com/in/yourprofile",
            ],
            offers: {
              "@type": "Offer",
              name: "Web Development Services",
              description: "Frontend development with React and Next.js",
            },
          })}
        </script>

        <link
          rel="preload"
          as="image"
          href="/images/centrumrolet-mockup.webp"
        />
        <link rel="preload" as="image" href="/images/mtdoors-mockup.webp" />
        <link
          rel="preload"
          as="image"
          href="/images/centrumrolet-mockup.webp"
        />
        <link rel="preload" as="image" href="/images/ajm-mockup.webp" />
      </Helmet>
      <div className="min-h-screen w-full">
        <Hero />
        <WorkMarguee />
        <Features />
        <Services />
        <Text />
        <Pricing />
        <About />
        <Certificates />
        <Tech />
        <Faq />
      </div>
    </>
  );
};

export default HomePage;
